import React, { useEffect } from 'react';
import { CardSection, CardTitle } from '../RelatedArticlesNew/styled';
import { ForwardArrow, QNAList, TopicsList } from '../RelatedQuestion/styled';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { removeDefaultParams } from '../../../Utils/helper';
import { images } from '../../../Constants/ImageUrls';
import {
  fireClickedCardEvent,
  fireServedSectionEvent,
} from '../../../Utils/useFirebase';

export default function RelatedArticleTopics(props) {
  const { topics, pageType } = props;

  function getUniqueTopic() {
    return [
      ...new Map(
        topics?.map((element) => [
          element['description'] || element['title'],
          element,
        ]),
      ).values(),
    ];
  }

  const uniqueTopic = getUniqueTopic();

  useEffect(() => {
    if (uniqueTopic?.length > 0) {
      let cardId = [];
      uniqueTopic.forEach((element) => {
        cardId.push(element.term_id || element?.id);
      });
      fireServedSectionEvent('related Topic', cardId, pageType);
    }
  }, [uniqueTopic]);
  const router = useRouter();

  return (
    <>
      {uniqueTopic.length > 0 ? (
        <CardSection>
          <CardTitle>Related Topics</CardTitle>
          <QNAList>
            {uniqueTopic?.map((element, index) => {
              return (
                <Link
                  href={{
                    pathname: element.web_url || element.webUrl,
                    query: removeDefaultParams(router.query),
                  }}
                  passHref
                  key={`related_topic${index}`}
                  locale={false}
                >
                  <li
                    key={`related_topic${index}`}
                    className={
                      uniqueTopic.length - 1 == index ? 'noBorder' : ''
                    }
                    onClick={() =>
                      fireClickedCardEvent(
                        'related Articles',
                        element.description || element.title,
                        pageType,
                        element.term_id || element?.id,
                      )
                    }
                  >
                    <TopicsList>
                      <span>{element.description || element.title}</span>

                      <ForwardArrow
                        src={images.arrowDownForward}
                        alt="forwardArrow"
                      />
                    </TopicsList>
                  </li>
                </Link>
              );
            })}
          </QNAList>
        </CardSection>
      ) : null}
    </>
  );
}
